import React, { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { capitalizeAll, ITEMS_PER_PAGE_50 } from '@moderepo/mode-app-components';
import { useRitzTranslation } from '../../utils/customHooks';
import { SCSensorModulesListingContainer } from './SCSensorModulesListingContainer';
import { SensorModuleContainer } from './SCUtils';


/**
 * This page display all sensor modules belonged to a home
 */
export const SCHomeSensorModulesPage: React.FC = () => {
    // Get the params from the route or url
    const params = useParams();
    const projectId = Number(params.projectId);
    const userId = params.userId ? Number(params.userId) : undefined;        // userId is OPTIONAL depending on which route the user is on
    const homeId = Number(params.homeId);

    const { state:dataState } = useContext(ritzDataContext);
    const project = selectProjectById(dataState, projectId);
    const { trans } = useRitzTranslation(project);

    const sensorModuleHiddenFields = useMemo(() => {
        return {
            interval: true,
            sensors : true,
        };
    }, []);


    return (
        <div className={clsx('page-main-content')}>
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.sensor_modules')}
                    </div>
                    <div className="page-subtitle">
                        {capitalizeAll(trans('page.subtitle.sensor_modules'))}
                    </div>
                </div>
            </div>


            {project && (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <SCSensorModulesListingContainer
                            projectId={projectId}
                            smContainer={SensorModuleContainer.HOME}
                            smContainerId={homeId}
                            userId={userId}
                            homeId={homeId}
                            itemsPerPage={ITEMS_PER_PAGE_50}
                            hiddenFields={sensorModuleHiddenFields}
                        />
                    </Grid>
                </Grid>
            )}

            {!project && (
                <CircularProgress />
            )}
        </div>
    );
};
